export default __webpack_public_path__ + "static/media/Breeches of the Masquer of the Sands.22a5bfa5.jpg";